/* VB · barra de anuncios: cada mitad del bucle se rellena con copias hasta cubrir el ancho visible y el track se mueve
   con requestAnimationFrame a velocidad constante, encajado al píxel físico (iconos y texto nítidos: una capa que se
   desplaza en fracciones de píxel se re-muestrea y los trazos de 0,7 px de Figma se ven borrosos). No se detiene con el
   ratón (QA 27-oct); solo con el foco de teclado dentro, fuera de pantalla o con «reducir movimiento».
   Arranque = composición de Figma: escritorio centrado (23650:3, primaryAxis CENTER), móvil a 16 px (23667:630). */
if (!customElements.get('vb-announcement')) {
  customElements.define('vb-announcement', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vb-ann-track]');
      this.halves = [...this.querySelectorAll('.vb-ann__half')];
      if (!this.track || this.halves.length < 2) return;
      this.base = [...this.halves[0].children].map((li) => li.cloneNode(true));
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.fill = this.fill.bind(this);
      this.tick = this.tick.bind(this);
      (document.fonts?.ready || Promise.resolve()).then(this.fill);
      this.ro = new ResizeObserver(() => { clearTimeout(this.t); this.t = setTimeout(this.fill, 120); });
      this.ro.observe(this);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(([e]) => { this.off = !e.isIntersecting; this.run(); });
        this.io.observe(this);
      }
      // Solo el foco de teclado detiene la barra (un clic de ratón en un enlace no)
      this.addEventListener('focusin', (e) => { this._kbd = e.target.matches(':focus-visible'); });
      this.addEventListener('focusout', () => { this._kbd = false; });
      this.reduce.addEventListener?.('change', this.fill);
    }
    disconnectedCallback() { this.ro?.disconnect(); this.io?.disconnect(); cancelAnimationFrame(this.raf); this.raf = 0; }
    fill() {
      const vw = this.clientWidth || window.innerWidth;
      const [a, b] = this.halves;
      const reset = (ul, clone) => {
        ul.innerHTML = '';
        this.base.forEach((li) => {
          const n = li.cloneNode(true);
          if (clone) { n.removeAttribute('data-shopify-editor-block'); n.querySelectorAll('a').forEach((x) => x.setAttribute('tabindex', '-1')); }
          ul.appendChild(n);
        });
      };
      reset(a, false); reset(b, true);
      const one = Math.ceil(a.getBoundingClientRect().width) || a.scrollWidth || 1;
      const reps = Math.max(1, Math.ceil(vw / one));
      for (let i = 1; i < reps; i++) this.base.forEach((li) => {
        const x = li.cloneNode(true); x.setAttribute('aria-hidden', 'true'); x.querySelectorAll('a').forEach((n) => n.setAttribute('tabindex', '-1')); a.appendChild(x);
        b.appendChild(x.cloneNode(true));
      });
      const base = parseFloat(getComputedStyle(this).getPropertyValue('--ann-speed')) || 40;
      const slow = this.mobile.matches ? 1.4 : 1;
      this.half = one * reps;
      this.speed = one / (base * slow); // px por segundo: una vuelta del set base en «Duración de una vuelta»
      const gap = parseFloat(getComputedStyle(a.firstElementChild || a).paddingRight) || 0;
      const start = this.mobile.matches ? 16 : Math.max(0, (vw - (one - gap)) / 2);
      this.x = start > 0 ? start - one : 0;
      this.track.setAttribute('data-raf', '');
      this.paint();
      this.run();
    }
    run() {
      const go = !this.reduce.matches && !this.off && this.half > 0;
      if (go && !this.raf) { this.last = 0; this.raf = requestAnimationFrame(this.tick); }
      if (!go && this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; }
      if (this.reduce.matches) { this.track.removeAttribute('data-raf'); this.track.style.transform = ''; }
    }
    tick(t) {
      const dt = this.last ? Math.min(0.05, (t - this.last) / 1000) : 0;
      this.last = t;
      if (!this._kbd) {
        this.x -= this.speed * dt;
        if (this.x <= -this.half) this.x += this.half;
      }
      this.paint();
      this.raf = requestAnimationFrame(this.tick);
    }
    paint() {
      const d = window.devicePixelRatio || 1;
      this.track.style.transform = `translate3d(${Math.round(this.x * d) / d}px,0,0)`;
    }
  });
}
